export default function isMobile (regex = '(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)') {
  return !!navigator.userAgent.match(new RegExp(regex, 'g'));
}
